import { useOrganizationUsersContext } from 'contexts/OrganizationUsersContext';
import { IUser } from 'types/user';

export type UseOrgUserResult = {
    user: IUser | undefined;
    isLoading: boolean;
};

/**
 * Resolves an org user by correlation id, for consumers that need the raw user
 * (e.g. an avatar picture) alongside the resolved name.
 */
export const useOrgUser = (correlationId: string | null | undefined): UseOrgUserResult => {
    const { getUser, isLoading } = useOrganizationUsersContext();
    return { user: getUser(correlationId), isLoading };
};
